import React from 'react'
import Footer from './Footer'
import Carousal from './Carousal'
import Section from '../pages/Section'
import Treatment from '../pages/Treatment'
import Photoes from './Photoes'
import Report from './Report'

const Layout = () => {
  return (
    <div>

      <Carousal />
      <Section />
      <Treatment />
      <Photoes />
<Report/>


      <Footer />
    </div>
  )
}

export default Layout